enum GenericsStatic {
  /**
   * @member {string}
   * @method GET
   * @version 2.0
   * @description get improvements list
   */
  Improvements = "/v2/realestates/improvements"
}

const GenericsDynamic = {
  // Aquí se pueden agregar endpoints dinámicos en el futuro si es necesario
};

export const GenericsEndpoints = {
  ...GenericsDynamic,
  ...GenericsStatic
};

export type GenericsEndpoints = typeof GenericsEndpoints;
